// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__1rAIk","container":"styles_container__2JSYp","close":"styles_close__38FBS"};